<template>
  <v-card>
    <v-card v-if="mpptShow">
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">전압 (V)</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">전류 (A)</v-col>
        <v-col class="d-flex justify-center uniqueCol noline" cols="3">전력 (kW)</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 1</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt1 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt1 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt1 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 2</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt2 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt2 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt2 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 3</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt3 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt3 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt3 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 4</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt4 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt4 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt4 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 5</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt5 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt5 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt5 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 6</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt6 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt6 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt6 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 7</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt7 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt7 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt7 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 8</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt8 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt8 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt8 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 9</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt9 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt9 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt9 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 10</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt10 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt10 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt10 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 11</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt11 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt11 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt11 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 12</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt12 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt12 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt12 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 13</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt13 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt13 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt13 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 14</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt14 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt14 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt14 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">MPPT 15</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Umppt15 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Imppt15 }}</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ unitedSiteInfo.Wmppt15 }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">Total</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3"></v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3"></v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="3">{{ totalW }}</v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center uniqueCol" cols="3">누설전류</v-col>
        <v-col class="d-flex justify-center uniqueCol" cols="9">{{unitedSiteInfo.GFCI ? unitedSiteInfo.GFCI : 0}} mA</v-col>
      </v-row>
    </v-card>
    <v-card v-else>
      <v-card class="mpptNotShow">
        <h1>인버터별로 조회해 주세요</h1>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
import { getSolraUnitedInverterWork } from '@/api/pcs/siteWork.js'

export default {
  name: 'MpptInfo',
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
    INVERTER_ID: {
      default: '',
      type: String
    },
    STATION_ID: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      unitedSiteInfo: {},
      mpptShow: true,
      totalW: 0
    }
  },
  mounted() {
    const siteId = this.$route.query.site_id
    const params =
      '?site_id=' +
      siteId +
      '&station_id=' +
      this.STATION_ID +
      '&inverter_id=' +
      this.INVERTER_ID
    if (this.INVERTER_ID) {
      getSolraUnitedInverterWork(params).then(rex => {
        this.unitedSiteInfo = rex.unitedSiteInfo
        if (this.unitedSiteInfo.isMppt === '12.0') {
          this.totalW = (
            Number(this.unitedSiteInfo.Wmppt1) +
            Number(this.unitedSiteInfo.Wmppt2) +
            Number(this.unitedSiteInfo.Wmppt3) +
            Number(this.unitedSiteInfo.Wmppt4) +
            Number(this.unitedSiteInfo.Wmppt5) +
            Number(this.unitedSiteInfo.Wmppt6) +
            Number(this.unitedSiteInfo.Wmppt7) +
            Number(this.unitedSiteInfo.Wmppt8) +
            Number(this.unitedSiteInfo.Wmppt9) +
            Number(this.unitedSiteInfo.Wmppt10) +
            Number(this.unitedSiteInfo.Wmppt11) +
            Number(this.unitedSiteInfo.Wmppt12) +
            Number(this.unitedSiteInfo.Wmppt13) +
            Number(this.unitedSiteInfo.Wmppt14) +
            Number(this.unitedSiteInfo.Wmppt15)
          ).toFixed(1)
        } else if (this.unitedSiteInfo.isMppt === '10.0') {
          this.totalW = (
            Number(this.unitedSiteInfo.Wmppt1) +
            Number(this.unitedSiteInfo.Wmppt2) +
            Number(this.unitedSiteInfo.Wmppt3) +
            Number(this.unitedSiteInfo.Wmppt4) +
            Number(this.unitedSiteInfo.Wmppt5) +
            Number(this.unitedSiteInfo.Wmppt6) +
            Number(this.unitedSiteInfo.Wmppt7) +
            Number(this.unitedSiteInfo.Wmppt8) +
            Number(this.unitedSiteInfo.Wmppt9) +
            Number(this.unitedSiteInfo.Wmppt10)
          ).toFixed(1)
        } else if (this.unitedSiteInfo.isMppt === '3.0') {
          this.totalW = (
            Number(this.unitedSiteInfo.Wmppt1) +
            Number(this.unitedSiteInfo.Wmppt2) +
            Number(this.unitedSiteInfo.Wmppt3)
          ).toFixed(1)
        } else if (this.unitedSiteInfo.isMppt === '0.0') {
          this.totalW = 0
        }
      })
    }
    if (!this.INVERTER_ID) {
      this.mpptShow = false
    } else {
      this.mpptShow = true
    }
  }
}
</script>

<style scoped>
.mpptNotShow {
  height: 510px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.uniqueCol {
  border: 1px solid #808080ba;
}
.noline {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
